import type { PageContext } from 'vike/types';
import { getSiteName } from 'src/utils/ssrMeta';
import type { PageData } from './+data';

// Program planner title: "Plan Your Season — <Program> | <Org> on <Site>".
export default (pageContext: PageContext): string => {
   const { orgName, programName } = (pageContext.data ?? {}) as PageData;
   const siteName = getSiteName(pageContext);
   const subject = programName || orgName;
   if (!subject) {
      return `Plan Your Season on ${siteName}`;
   }
   const base = `Plan Your Season — ${subject}`;
   return orgName && orgName !== subject ? `${base} | ${orgName} on ${siteName}` : `${base} on ${siteName}`;
};
